import { areValidationsRestrictedForBackoffice } from "@/services/config";
import store from "@/store";

const canAccessValidation = () => {
  if (store.getters.isPatient || store.getters.isAdmissionist) {
    return false;
  }
  if (areValidationsRestrictedForBackoffice) {
    return (
      !store.getters.isAdmin &&
      !store.getters.isAssistant &&
      !store.getters.isManager
    );
  }
  return true;
};

const validationRoutes = [
  {
    path: "/validation",
    name: "validation",
    meta: {
      condition: canAccessValidation,
      redirectTo: { name: "home" },
    },
    component: () =>
      import(
        /* webpackChunkName: "validation" */ "../components/validation/Validation.vue"
      ),
  },
  {
    path: "/validation/history",
    name: "validation-history",
    meta: {
      condition: canAccessValidation,
      redirectTo: { name: "home" },
    },
    component: () =>
      import(
        /* webpackChunkName: "validation" */ "../components/validation/ValidationHistory.vue"
      ),
  },
];

export default validationRoutes;
